export default __webpack_public_path__ + "static/media/3d-to-2d-python.a00b273a.jpg";